import { createContext, useContext } from "react";

export const ExecutionStepsContext = createContext();

export function useExecutionStepsContext() {
  return useContext(ExecutionStepsContext);
}
